import { Injectable } from "@angular/core";
import { BaseChatWidgetService } from "@rrsolutionsit/atl-chatbot-lib";

@Injectable({ providedIn: "root" })
export class ChatbotService extends BaseChatWidgetService {}
